module.exports = __webpack_public_path__ + "static/media/cosplay10.84476ff3.jpg";